let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";
import i18n from "../../utils/i18n";
import ModalView from "../comp/ModalView.js";
let MenuItemOptions = require("../../templates/settings/MenuItemOptions.handlebars");

import React from 'react';
import ReactDOM from 'react-dom';
import MenuItemSelector from '../../react/common/MenuItemSelector';

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .save": "save",
            "click .resetPrinter": "_resetPrinter",
            "click .tab-container .nav li": "switchTab",
            "click .btn.add-tag": "_addTag",
            "click .tags .tag": "_showTag",
            "click .add-popup": "addPopup",
            "click .categories .category:not(.active)": "_selectCategory",
            "click .categories .category.active": "_unSelectCategory",
            "click .menu-items .menu-item": "_toggleMenuItem",
            "click .btn.save-usage": "_saveUsage",
            "click .modal .delete": "_removeTag",
            "click .receipts .label-checkbox": "_checkedReceipt",
            "change .form-group .printer-list": "_changePrinter",
            "click .btn.save-setting": "_saveSetting",
            "click .btn.add-setting": "_addSetting",
            "click .btn.delete-setting": "_deleteSetting",
            'click .radio-btn': '_clickRadio',
            'click .check-box': '_clickCheckbox',
            "click .btn.add-usage": "addUsage",
            "click .print-usage .item": "removeUsageItem",
            "change select.category-selector": "selectCategory",
            "click .ok": "_saveTag",
            'click .printer-tag .add-printertag': '_addPrinterTag',
            "click .tag-item": "_removePrinterTag",
            "change .setting-pane .label-radio input[type='radio']": "_changeType",
            "change .cloud-setting-pane .label-radio input[type='radio']": "_changeType"
        },

        currentTag: null,
        ls: window.localStorage,
        initialize: function () {
            var self = this;
            if (window.AndroidClient) {
                self._printerRefresh();
                $(".setting-printer").removeClass("hidden");
            }
            this.cloudPrintSelectionChanged(self.$(".printer-setting input[checked='checked']").val() == 'true');
        },

        string2JSON: function (string) {
            return JSON.parse(string);
        },
        JSON2String: function (json) {
            return JSON.stringify(json);
        },
        _changeType: function (evt) {
            this._changeTypeStyle($(evt.currentTarget).val());
        },
        $currentSettingPane: function () {
            var cloudSettingSelected = this.$(".cloud-setting-pane").hasClass('active');
            if (cloudSettingSelected) {
                return this.$(".cloud-setting-pane");
            } else {
                return this.$(".setting-pane");
            }
        },
        _changeTypeStyle: function (type) {
            console.log("changing type to ", type);
            if (type == "tagPrinter") {
                this.$currentSettingPane().find(".tag").removeClass('hidden');
                this.$currentSettingPane().find(".net").addClass('hidden');
                this.$currentSettingPane().find("input[value=tagPrinter]").prop('checked', true);
                this.$currentSettingPane().find("input[value=network]").prop('checked', false);
            } else {
                this.$currentSettingPane().find(".net").removeClass('hidden');
                this.$currentSettingPane().find(".tag").addClass('hidden');
                this.$currentSettingPane().find("input[value=tagPrinter]").prop('checked', false);
                this.$currentSettingPane().find("input[value=network]").prop('checked', true);
            }
        },
        render: function () {
            return this;
        },
        addUsage: function () {
            var self = this, option,
                categorySelector = self.$(".category-selector"),
                menuItemSelector = self.$(".menu-item-selector");
            if (parseInt(menuItemSelector.val()) !== 0) {
                option = menuItemSelector.find("option:selected");
                self.appendUsageItem("menu-item", option);
                option.addClass("selected");
            } else if (parseInt(categorySelector.val()) !== 0) {
                option = categorySelector.find("option:selected");
                self.appendUsageItem("category", option);
                option.addClass("selected");
            }
        },
        removeUsageItem: function (evt) {
            $(evt.currentTarget).closest(".item").addClass("removed");
        },
        selectCategory: function (evt) {
            var self = this, options, optionsClone,
                categorySelector = self.$(".category-selector"),
                menuItemSelector = self.$(".menu-item-selector");
            options = MenuItemOptions({
                items: categorySelector.val() == "0" ? null : POS.getMenu().getCategories().get(parseInt(categorySelector.val())).get("menuItems").toJSON()
            });
            optionsClone = $(options).clone();
            _.each(self.$(".tag-items .item"), function (usage) {
                _.each($(optionsClone).find("option"), function (option) {
                    if ($(option).val() == $(usage).data("itemid").toString()) {
                        console.log("val = ", $(option).val());
                        console.log("val = ", $(usage).data("itemid").toString());
                        $(option).remove();
                    }
                });
                if (categorySelector.val() == 0) {
                    $(usage).show();
                } else if ($(usage).data("cateid") != categorySelector.val()) {
                    $(usage).hide();
                } else {
                    $(usage).show();
                }
            });
            self.$(".tag-title").text(categorySelector.val() == 0 ? "全部餐品" : $(evt.currentTarget).find("option:selected").text());
            menuItemSelector.html(optionsClone.html());
        },
        _clickRadio: function (event) {
            var _this = $(event.currentTarget),
                block = _this.closest(".form-group");
            block.find('input:radio').attr('checked', false);
            block.find(".radio-btn").removeClass('checkedRadio');
            _this.addClass('checkedRadio');
            _this.find('input:radio').attr('checked', true);

            var checkbox = _this.find("input[type=radio]");
            if (checkbox.attr("name") == 'cloudPrint') {
                this.cloudPrintSelectionChanged(checkbox.attr("value") == 'true')
            }
        },

        cloudPrintSelectionChanged(selected) {
            console.log("cloud print? " + selected);
            this.$('li.cloud-setting-printer').toggleClass('hidden', !selected);
        },

        _clickCheckbox: function (event) {
            var _this = $(event.currentTarget),
                checkbox = _this.find(':checkbox');
            checkbox.attr('checked', !checkbox.attr('checked'));
            _this.toggleClass('checkedBox');
        },

        _changePrinter: function () {
            var self = this,
                printerName = this.$currentSettingPane().find(".printer-list").val(),
                localList = this._getPrinterSetting(),
                addBtn = this.$currentSettingPane().find(".add-setting"),
                saveBtn = this.$currentSettingPane().find(".save-setting"),
                deleteBtn = this.$currentSettingPane().find(".delete-setting");
            if (printerName == i18n.msg('pos.printer.config.setting.list.defaultlabel') || printerName == "") {
                addBtn.removeClass("hidden").siblings('.savebtn').addClass('hidden');
            } else {
                addBtn.addClass("hidden").siblings('.savebtn').removeClass('hidden');
            }
            if (localList.length > 0) {
                _.each(localList, function (printer) {
                    if (printer.name == printerName) {
                        self._changeTypeStyle(printer.type);
                        self.$currentSettingPane().find(".printer-width").val(printer.width);
                        self.$currentSettingPane().find(".printer-ip").val(printer.ip);
                        self.$currentSettingPane().find(".printer-name").val(printer.name);
                        self.$currentSettingPane().find(".tagWidth").val(printer.tagWidth);
                        self.$currentSettingPane().find(".tagHeight").val(printer.tagHeight);
                        self.$currentSettingPane().find(".tagGap").val(printer.tagGap);
                        self.$currentSettingPane().find(".autoPeel").prop('checked', printer.autoPeel);
                        self._refreshTypes(printer.types);
                        self._refreshTag(printer.tags);
                    }
                });
            }
        },
        _getPrinterSetting: function () {
            var cloudSettingSelected = this.$(".cloud-setting-pane").hasClass('active');
            if (cloudSettingSelected) {
                console.log("retrieving cloud printer setting");
                return POS.getCloudPrintSettings();
            } else {
                console.log("retrieving local printer setting");
                return this.string2JSON(this.ls.getItem("networkPrinterSetting")) || [];
            }
        },
        _setPrinterSetting: function (settings) {
            POS.showLoading(true);
            var cloudSettingSelected = this.$(".cloud-setting-pane").hasClass('active');
            if (cloudSettingSelected) {
                console.log("updating cloud printer setting");
                POS.setCloudPrintSettings(settings);
                this.save();
            } else {
                console.log("updating local printer setting");
                this.ls.setItem("networkPrinterSetting", this.JSON2String(settings));
                _.delay(_.bind(function () {
                    POS.showLoading(false);
                }, this), 100);
            }
        },
        _printerRefresh: function () {
            var self = this, listPrinter = this.$currentSettingPane().find(".list-printer"),
                localList = this._getPrinterSetting();
            var selected = listPrinter.find('.printer-list').val();
            self._changeTypeStyle('network');
            if (localList.length > 0) {
                var printList = listPrinter.find('.printer-list');
                listPrinter.removeClass("hidden");
                printList.empty().append("<option>" + i18n.msg('pos.printer.config.setting.list.defaultlabel') + "</option>");
                _.each(localList, function (printer) {
                    if (selected == printer.name) {
                        self._changeTypeStyle(printer.type);
                    }
                    printList.append("<option value='" + printer.name + "' " + (selected == printer.name ? 'selected' : '') + ">" + printer.name + "</option>");
                });
            } else {
                self._changeTypeStyle('network');
                listPrinter.addClass("hidden");
            }
        },
        _refreshTag: function (tags) {
            var self = this;
            self.$currentSettingPane().find(".tags .tags-printer").empty();
            if (tags.length > 0) {
                _.each(tags, function (tag) {
                    self.$currentSettingPane().find(".tags .tags-printer").prepend(self._buildTagTemplate(tag));
                });
            }
        },
        _refreshTypes: function (types) {
            var self = this;
            _.each(self.$currentSettingPane().find(".receipts .receipt input"), function (receiptItem) {
                var flag = false;
                _.each(types, function (type, index) {
                    if (type == $(receiptItem).data("type")) {
                        flag = true;
                    }
                });
                if (flag) {
                    $(receiptItem).prop("checked", true);
                } else {
                    $(receiptItem).prop("checked", false);
                }
            });
        },
        _saveTag: function () {
            var self = this, field, fieldWrapper, focusField, jxhr, params = {},
                usages = {worked: {items: []}, removed: {items: []}},
                tagList = self.$(".print-usage .worked-items .item"),
                tagStore = POS.get("printerTags"),
                id = this.$('.modal').data('id'),
                url = id ? '/printer/updateTag/' + id : '/printer/saveTag',
                tagTemplate = self.$(".tags .tag.hidden").clone().removeClass("hidden");
            field = self.$(".field input");
            fieldWrapper = field.closest(".field");
            field.val(field.val().trim());
            if (!field.val() && fieldWrapper.hasClass("required")) {
                fieldWrapper.addClass("has-error");
                if (!focusField) {
                    focusField = field;
                    focusField.focus();
                }
            } else {
                fieldWrapper.removeClass("has-error");
            }
            if (self.$(".field.has-error").length > 0) {
                return false;
            }
            params.name = field.val();
            if (tagList.length > 0) {
                usages.worked.items = new Array();
                _.each(tagList, function (item) {
                    item = $(item);
                    if (item.is(".removed")) {
                        usages.removed.items = usages.removed.items || [];
                        usages.removed.items.push(item.data("id"));
                    } else {
                        usages.worked.items.push(item.data("id"));
                    }
                });
            }
            const categoryUsageMap = this.$('#printerUsageMap').val();
            if (categoryUsageMap) {
                params.usagesJson = categoryUsageMap;
            }
            jxhr = $.post(url, params);
            POS.showLoading(true);
            jxhr.done(function (response) {
                if (response.success) {
                    if (id) {
                        self.$('.tags').find(".tag[data-id='" + id + "']").remove();
                        tagTemplate.attr("data-id", response.tag.id);
                        tagTemplate.attr("data-name", response.tag.name);
                        tagTemplate.find(".name").text(response.tag.name);
                        self.$(".tags").append(tagTemplate);
                    } else {
                        tagStore.push(response.tag);
                        tagTemplate.attr("data-id", response.tag.id);
                        tagTemplate.attr("data-name", response.tag.name);
                        tagTemplate.find(".name").text(response.tag.name);
                        self.$(".tags").append(tagTemplate);
                    }
                    self.trigger('needRefresh');
                }
            });
            jxhr.fail(function (response) {

            });
            jxhr.always(function () {
                self._checkTags();
                self.$('.modal').modal('hide');
                POS.showLoading(false);
            })
        },
        switchTab: function (event) {
            var li = $(event.currentTarget), container = li.closest(".tab-container");
            li.addClass('active').siblings('li').removeClass('active');
            container.find(".tab-pane").removeClass("active");
            container.find(".tab-pane." + li.data("target")).addClass("active");
            // if (li.data("target") == "basic-pane") {
            //     this.tooltips.setTipsBody({
            //         title: "print.base",
            //         content: "print.base"
            //     });
            // } else {
            //     this.tooltips.setTipsBody({
            //         title: "print.tag",
            //         content: "print.tag"
            //     });
            // }
            this._printerRefresh();
        },
        _checkedReceipt: function (evt) {
            var target = $(evt.currentTarget);
            target.siblings("input").prop("checked", !target.siblings("input").prop("checked"));
        },
        _resetPrinter: function () {
            var self = this;
            if (confirm(i18n.msg('pos.setting.print.reset'))) {
                self.ls.removeItem("printer");
                self.$(".printer-select").text("").append("<option disabled>" + i18n.msg('pos.setting.print.selectPrinter') + "</option>");
                var params = {
                        paymentReceipt: false,
                        orderReceipt: false,
                        itemSlip: false,
                        returnSlip: false,
                        id: POS.get('rId')
                    },
                    result = $.post('/pos/printSetting', params);
                POS.showLoading(true);
                result.done(function (res) {
                    self.$(".printer-setting").hide();
                });

                result.fail(function () {
                    self.showMsg(i18n.msg("pos.setting.print.notSaved"), 'alert-error');
                });
                result.always(function (response) {
                    POS.showLoading(false);
                });
            }
        },
        _selectOption: function (name, width) {
            return "<option value='" + name + "," + width + "'>" + i18n.msg("pos.setting.print.printerName") + name + ";" + i18n.msg("pos.setting.print.printerWidth") + width + "</option>";
        },

        _deleteSetting: function () {
            var self = this, types = [],
                printerList = this._getPrinterSetting(),
                printerDom = self.$currentSettingPane().find(".list-printer"),
                addBtn = self.$currentSettingPane().find(".add-setting");
            if (confirm(i18n.msg('pos.printer.config.setting.delete.confirm'))) {
                var printSel = printerDom.find('.printer-list');
                _.each(printerList, function (value, index) {
                    if (printSel.val() == value.name) {
                        printerList.splice(index, 1);
                        self._setPrinterSetting(printerList);
                    }
                });
                if (printerList.length == 0) {
                    printSel.empty();
                    printerDom.addClass('hidden');
                }
                self.$currentSettingPane().find("input[type=text]").val("");
                self.$currentSettingPane().find("input[type=checkbox]").prop('checked', false);
                addBtn.removeClass("hidden").siblings('.savebtn').addClass('hidden');
                self._printerRefresh();
            }
        },
        _addSetting: function () {
            var self = this, types = [], tags = [],
                printerList = this._getPrinterSetting(),
                printerDom = self.$currentSettingPane().find(".printer-list"), params = {};
            self.$('.alert').addClass('hidden');
            _.each(self.$currentSettingPane().find("input[type='text']"), function (item) {
                $(item).closest(".form-group").removeClass('has-error');
                if ($(item).val() === "" && !$(item).closest(".form-group").hasClass('hidden')) {
                    $(item).closest(".form-group").addClass('has-error');
                } else {
                    params[item.name] = $(item).val();
                }
            });
            if (self.$currentSettingPane().find(".form-group.has-error").length > 0) {
                return false;
            }
            params["type"] = self.$currentSettingPane().find("input[name='type']:checked").val();
            params.autoPeel = self.$currentSettingPane().find("input[name='autoPeel']").prop('checked');
            self.$currentSettingPane().find('.receipts .receipt input').filter(function (it, value) {
                if ($(value).prop('checked')) {
                    types.push($(value).data('type'))
                }
            });
            self.$currentSettingPane().find('.tags .tag-printer').each(function (index, value) {
                tags.push($(value).text());
            });
            params.types = types;
            params.tags = tags;
            params.tagsAll = self.$currentSettingPane().find('.tagsAll').val();
            if (printerList.length === 0) {
                printerList.push(params);
            } else {
                var exist = printerList.filter(function (value, index) {
                    if (value.name == params.name) {
                        return value;
                    }
                });
                if (exist.length === 0) {
                    printerList.push(params);
                } else {
                    printerList.splice(printerList.indexOf(exist[0]), 1, params);
                }
            }
            self._setPrinterSetting(printerList);
            self._printerRefresh();
            printerDom.closest('.list-printer').removeClass("hidden");
        },
        _saveSetting: function () {
            var self = this, types = [], tags = [],
                printerList = this._getPrinterSetting(),
                printerDom = self.$currentSettingPane().find(".printer-list"), params = {};
            self.$('.alert').addClass('hidden');
            _.each(self.$currentSettingPane().find("input[type='text']"), function (item) {
                $(item).closest(".form-group").removeClass('has-error');
                if ($(item).val() === "" && !$(item).closest(".form-group").hasClass('hidden')) {
                    $(item).closest(".form-group").addClass('has-error');
                } else {
                    params[item.name] = $(item).val();
                }
            });
            if (self.$currentSettingPane().find(".form-group.has-error").length > 0) {
                return false;
            }
            params["type"] = self.$currentSettingPane().find("input[name='type']:checked").val();
            params.autoPeel = self.$currentSettingPane().find("input[name='autoPeel']").prop('checked');
            self.$currentSettingPane().find('.receipts .receipt input').filter(function (it, value) {
                if ($(value).prop('checked')) {
                    types.push($(value).data('type'))
                }
            });
            self.$currentSettingPane().find('.tags .tag-printer').each(function (index, value) {
                tags.push($(value).text());
            });
            params.types = types;
            params.tags = tags;
            params.tagsAll = self.$currentSettingPane().find('.tagsAll').val();
            _.each(printerList, function (value, index) {
                if (value.name == printerDom.val()) {
                    value = params;
                    printerList[index] = value;
                }
            });
            self._setPrinterSetting(printerList);
            self._printerRefresh();
        },
        save: function () {
            this.$('.alert').addClass('hidden');
            var params = {
                    paymentReceipt: this.$('.payment').prop('checked'),
                    orderReceipt: this.$('.order').prop('checked'),
                    itemSlip: this.$('.item').prop('checked'),
                    dispatchSlip: this.$('.dispatch').prop('checked'),
                    returnSlip: this.$('.return').prop('checked'),
                    tagSlip: this.$('.tagSlip').prop('checked'),
                    cloudPrint: this.$(".cloudPrint[checked='checked']").val(),
                    cloudPrintSettings: this.JSON2String(POS.getCloudPrintSettings()),
                    id: POS.get('rId'),
                    customerContent: this.$('.customerContent').val()
                },
                result = $.post('/pos/printSetting', params), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    self.showMsg(i18n.msg("pos.setting.print.saved"), 'alert-success');
                    self.trigger('needRefresh');
                    self.$('.saveSuccessDiv').removeClass('hidden');
                    setTimeout(function () {
                        self.$('.saveSuccessDiv').addClass('hidden')
                    }, 1000);
                } else {
                    self.showMsg(i18n.msg("pos.setting.print.notSaved"), 'alert-error');
                }
            });

            result.fail(function () {
                self.showMsg(i18n.msg("pos.setting.print.notSaved"), 'alert-error');
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
            return false;
        },

        showMsg: function (msg, type) {
            this.$('.alert').removeClass('hidden').addClass(type).find('.content').text(msg);
        },
        appendUsageItem: function (type, option) {
            var self = this;
            var options = (type == "category") ? this.$(".menu-item-selector option:not(.selected)") : option;
            var added = [];
            $.each(options, function (index, val) {
                var id = $(val).val(), selector = ("printUsageItem-" + id);
                if (self.$("#" + selector).size() > 0) {
                    if (self.$("#" + selector).hasClass("removed")) {
                        self.$("#" + selector).removeClass("removed");
                    } else {
                        added.push($(val).text());
                    }
                } else if (id > 0 && self.$("#" + selector).size() == 0) {
                    var item = $("<div id='" + selector + "' class='item'>" + $(val).text() + "<span class='delete-item'>x</span> </div> ");
                    item.data("id", id);
                }
                self.$(".tag-items").append(item);
            });
            if (added.length > 0) {
                var modalModel = new Backbone.Model();
                var modalView = new ModalView({model: modalModel});
                modalView.body("<div style='text-align: center; padding: 10px'>" + i18n.msg("pos.discount.usage.duplicate", added.join(", ")) + "</div>");
                modalView.confirmButtonName(i18n.msg("pos.confirm"));
                modalView.$el.find('.modal-content').addClass('settingsModal');
                modalView.$el.find('.btn-confirm').addClass('saveCreate-btn');
                modalView.render();
                modalModel.once("change", function () {
                    modalView.close();
                });
            }
        },
        _removePrinterTag: function (event) {
            var tagItem = $(event.currentTarget);
            tagItem.slideUp(function () {
                tagItem.remove();
            });
        },
        _addPrinterTag: function () {
            var self = this, tag = $.trim(self.$currentSettingPane().find(".tag-input").val());
            if (!tag || tag.length > 50) {
                self.$currentSettingPane().find(".tag-input").focus();
                return false;
            }
            self.$currentSettingPane().find(".tags .tags-printer").prepend(self._buildTagTemplate(tag));
            self.$currentSettingPane().find(".tag-input").val("");
            return false;
        },
        _buildTagTemplate: function (tag) {
            var array = ["label-default", "label-primary", "label-success", "label-info", "label-warning", "label-danger"];
            var color = array[Math.floor(Math.random() * 6)];
            return "<li class='tag-item'><span class='label " + color + " tag-printer'>" + tag + "</span></li>";
        },
        _addTag: function () {
            var self = this, modal = this.$('.modal'), jxhr, className;
            var categorySelector = self.$(".category-selector");
            categorySelector.val(0);
            categorySelector.trigger("change");
            modal.find('.item-search').val("");
            modal.find('.search-panel').hide();
            modal.find('.modal-title.create').removeClass('hidden');
            modal.find('.modal-title.edit').addClass('hidden');
            modal.find('.has-error').removeClass('.has-error');
            modal.data('id', 0);
            modal.find('.help-block').text('');
            modal.find('.delete').addClass('hidden');
            modal.find('.tagName').val('');
            modal.find('.tagName').addClass("create");
            modal.find('.ok').removeClass('saveEdit-btn').addClass('saveCreate-btn');
            self.$(".tag-items").empty();
            self.$('.modal').modal('show');
        },
        _checkTags: function () {
            var self = this;
            if (self.$('.tags .tag').not('.hidden').length == 0) {
                self.$('.tagsFirsttime').removeClass("hidden");
                self.$('.has-tags').addClass("hidden");
            } else {
                self.$('.tagsFirsttime').addClass("hidden");
                self.$('.has-tags').removeClass("hidden");
            }
        },
        _searchItem: function () {
            var inputText = this.$(".item-search").val(), self = this,
                categorySelector = this.$(".category-selector");
            var exist = false;
            _.each(this.$(".tag-items .item"), function (usage) {
                var shortCode = $(usage).data("shortcode");
                var menuItem = $(usage).data("name");
                if (shortCode == inputText || inputText == menuItem) {
                    $(usage).show();
                    categorySelector.val($(usage).data("cateid"));
                    categorySelector.trigger("change");
                    exist = true;
                } else {
                    $(usage).hide();
                }
            });
            if (exist) {
                this.$(".tag-title").text("查找餐品");
            } else {
                _.each(POS.getMenu().getCategories().toJSON(), function (cate) {
                    var nameItem = cate.menuItems.findWhere({name: inputText});
                    var shortCodeItem = cate.menuItems.findWhere({shortCode: inputText});
                    if (nameItem) {
                        exist = true;
                        categorySelector.val(nameItem.get("categoryId"));
                        categorySelector.trigger("change");
                        self.$(".tag-title").text(nameItem.get("category").name);
                    }
                    if (shortCodeItem) {
                        exist = true;
                        categorySelector.val(shortCodeItem.get("categoryId"));
                        categorySelector.trigger("change");
                        self.$(".tag-title").text(shortCodeItem.get("category").name);
                    }
                });
            }
            if (!exist) {
                self.$(".tag-title").text("未找到任何餐品");
            }
        },
        addPopup: function (evt) {
            console.log("click", evt);
            const categoryString = this.$('#printerUsageMap').val();
            let categoryMap = categoryString ? JSON.parse(categoryString) : {};
            const root = $('<div></div>');
            const self = this;
            if ($(evt.currentTarget).closest("div").siblings(".tagName").hasClass("create")) {
                categoryMap = null;
            }
            $('body').append(root);
            ReactDOM.render(
                <MenuItemSelector
                    categoryMap={categoryMap}
                    onClose={(categories) => {
                        console.log('categories selected ', categories);
                        ReactDOM.unmountComponentAtNode(root.get(0));
                        root.remove();
                        self.$('#printerUsageMap').remove();
                        const categoryUsage = $('<input id="printerUsageMap" type="hidden"/>');
                        categoryUsage.val(JSON.stringify(categories));
                        self.$el.append(categoryUsage);
                    }}
                />, root.get(0));
        },
        _showTag: function (event) {
            var self = this, modal = this.$('.modal'), jxhr, className;
            var categorySelector = self.$(".category-selector");
            categorySelector.val(0);
            categorySelector.trigger("change");
            modal.find('.item-search').val("");
            modal.find('.search-panel').show();
            modal.find('.has-error').removeClass('.has-error');
            modal.find('.help-block').text('');
            modal.find('.delete').removeClass('hidden');
            modal.find('.modal-title.create').addClass('hidden');
            modal.find('.modal-title.edit').removeClass('hidden');
            modal.find('.ok').removeClass('saveCreate-btn').addClass('saveEdit-btn');
            var ele = $(event.currentTarget), id = ele.data('id'), name = ele.data('name');
            modal.find('.tagName').val(name);
            modal.find('.tagName').removeClass("create");
            self.$(".tag-items").empty();
            this.$("#printerUsageMap").remove();
            jxhr = $.post('/printer/usages', {id: id});
            POS.showLoading(true);
            jxhr.done(function (response) {
                console.log(response);
                if (response.usages) {
                    const categoryUsage = $('<input id="printerUsageMap" type="hidden"/>');
                    const categoryMap = {};
                    if (response.usages.categories) {
                        _.each(response.usages.categories, function (cate) {
                            categoryMap[cate.id] = cate;
                            categoryMap[cate.id].allItems = true;
                        });
                    }
                    if (response.usages.items) {
                        _.each(response.usages.items, function (item) {
                            let cat = categoryMap[item.cateId];
                            if (!cat) {
                                cat = {id: item.cateId, items: [{id: item.id, name: item.name}], allItems: false};
                                categoryMap[item.cateId] = cat;
                            } else {
                                cat.items = cat.items.concat({id: item.id, name: item.name});
                            }
                        });
                    }
                    categoryUsage.val(JSON.stringify(categoryMap));
                    self.$el.append(categoryUsage);
                }
            });
            jxhr.fail(function (response) {
                self.$('.modal .help-block').text(response);
            });
            jxhr.always(function (response) {
                self.$('.modal').data('id', id).data('name', name).modal('show');
                POS.showLoading(false);
            });
        },
        _updateCategoryUsageHint: function (category) {
            var self = this, totalItemsCount, selectedItemCount;
            totalItemsCount = self.$(".menu-items .menu-item[data-category-id=" + category.data("id") + "]").length;
            selectedItemCount = self.$(".menu-items .menu-item.selected[data-category-id=" + category.data("id") + "]").length;
            if ((totalItemsCount > 0) && (selectedItemCount > 0)) {
                category.find(".usage-background").css("width", (100 * selectedItemCount / totalItemsCount) + "%");
            } else {
                category.find(".usage-background").width(0);
            }
        },
        _selectCategory: function (event) {
            var self = this, category = $(event.currentTarget);
            category.addClass("active").siblings().removeClass("active").addClass("hidden");
            self.$(".menu-items .menu-item").addClass("hidden");
            self.$(".menu-items .menu-item[data-category-id=" + category.data("id") + "]").removeClass("hidden");
        },
        _unSelectCategory: function (event) {
            var self = this, category = $(event.currentTarget);
            category.removeClass("active").siblings().removeClass("hidden");
            self.$(".menu-items .menu-item").addClass("hidden");
        },
        _toggleMenuItem: function (event) {
            var self = this, menuItem = $(event.currentTarget);
            menuItem.toggleClass("selected");
            self._updateCategoryUsageHint(self.$(".category[data-id=" + menuItem.data("categoryId") + "]"));
        },
        _saveUsage: function () {
            var self = this, newItemIds, removedItemsIds, jxhr,
                params = {id: self.currentTag.id, restaurantId: POS.getRestaurant().id},
                tagStore = _.findWhere(POS.get("printerTags"), {id: self.currentTag.id}),
                category = self.$(".category.active");
            // newItems = self.$(".menu-item.selected:not(.server)"),
            // removedItems = self.$(".menu-item.server:not(.selected)");
            // newItemIds = _.map(newItems, function (item) {
            //     return $(item).data("id")
            // });
            // removedItemsIds = _.map(removedItems, function (item) {
            //     return $(item).data("id")
            // });
            // params.newItemIds = (newItemIds || []).join(",");
            // params.removedItemIds = (removedItemsIds || []).join(",");
            const categoryUsageMap = this.$('#printerUsageMap').val();
            if (categoryUsageMap) {
                params.usagesJson = categoryUsageMap;
            }
            jxhr = $.post("/printer/updateTagUsage", params);
            POS.showLoading(true);
            jxhr.done(function (response) {
                // _.each(removedItems, function (item) {
                //     $(item).removeClass("server");
                // });
                // _.each(newItems, function (item) {
                //     $(item).addClass("server");
                // });
                // tagStore.itemIds = _.map(self.$(".menu-item.selected"), function (item) {
                //     return $(item).data("id");
                // });
                new ModalView({
                    body: "<h3 style='text-align: center;'>" + i18n.msg('pos.action.success.save') + "</h3>",
                    hideFooter: true
                }).render();
                // if (category.length == 1) {
                //     self._updateCategoryUsageHint(category);
                //     category.click();
                // }
            });
            jxhr.fail(function (response) {
                new ModalView({
                    body: "<h3 style='text-align: center;'>" + i18n.msg('pos.action.failure.save') + "</h3>",
                    hideFooter: true
                }).render();
            });
            jxhr.always(function (response) {
                POS.showLoading(false);
            });
        },
        _removeTag: function () {
            var self = this, jxhr, tagIndex, tagStore = POS.get("printerTags"),
                confirmModel = new Backbone.Model(), id = this.$('.modal').data('id');
            confirmModel.on("change:shouldConfirm", function () {
                confirmModel.set({confirmed: true});
                jxhr = $.post("/printer/removeTag", {id: id});
                POS.showLoading(true);
                jxhr.done(function (response) {
                    for (tagIndex = 0; tagIndex < tagStore.length; tagIndex++) {
                        if (tagStore[tagIndex].id == id) {
                            tagStore.splice(tagIndex, 1);
                            break;
                        }
                    }
                    self.$('.tags').find(".tag[data-id='" + id + "']").remove();
                    self.$('.modal').modal('hide');
                    self._checkTags();
                    self.trigger('needRefresh');
                });
                jxhr.fail(function (response) {
                    new ModalView({
                        body: "<div style='text-align: center;line-height: 33px;'>" + i18n.msg('pos.action.failure.delete') + "</div>",
                        hideFooter: true
                    }).render();
                });
                jxhr.always(function (response) {
                    POS.showLoading(false);
                });
            });
            var deleteModal = new ModalView({
                body: "<div style='text-align: center;font-size: 18px;padding-top: 15px'>" + i18n.msg('pos.printer.action.delete.confirm') + "</div>",
                model: confirmModel,
                save: '删除'
            }).render();
            deleteModal.$el.find('.modal-content').addClass('settingsModal');
            deleteModal.$el.find('.btn-confirm').addClass('saveCreate-btn');
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/PrintSettingView.js